import { masterSetupAxiosInstance } from '../../axios/masterSetupAxios';

const getSmeStaffProduct = async (requestData: any) => {
  const params = {
    filters: requestData.params?.filters,
    search: requestData.params?.search,
    sortField: requestData.params?.sortField,
    sortOrder: requestData.params?.sortOrder,
    currentPage: requestData.params?.pagination.current,
    pageSize: requestData.params?.pagination.pageSize,
  };

  const url = `/redCash/master/api/v1.0/staff/product`;
  const res = await masterSetupAxiosInstance.get(url, { params });
  return res.data;
};

const createSmeStaffProduct = async (requestData: any) => {
  const url = `/redCash/master/api/v1.0/staff/product`;
  const res = await masterSetupAxiosInstance.post(url, requestData);
  return res.data;
};

const updateSmeStaffProduct = async (requestData: any) => {
  const { id, payload } = requestData;
  const url = `/redCash/master/api/v1.0/staff/product/${id}`;
  const res = await masterSetupAxiosInstance.patch(url, payload);
  return res.data;
};

const deleteSmeStaffProductById = async (requestData: any) => {
  const { id } = requestData;
  const url = `/redCash/master/api/v1.0/staff/product/${id}`;
  const res = await masterSetupAxiosInstance.delete(url);
  return res.data;
};

const staffProductService = {
  getSmeStaffProduct,
  createSmeStaffProduct,
  updateSmeStaffProduct,
  deleteSmeStaffProductById,
};

export default staffProductService;
